import classNames from 'classnames';
import styles from './PageIndicator.module.scss';
import { Theme } from '@shared/models/theme';

interface PageIndicatorProps {
  pageId: string;
  currentPagePaginationTime?: number;
  currentPageIndex: number;
  pages: number;
  onPaging: () => void;
  theme?: Theme;
}

export default function PageIndicator({
  pageId,
  currentPagePaginationTime,
  currentPageIndex,
  pages,
  onPaging,
  theme,
}: PageIndicatorProps) {
  return (
    <div className={styles.pages}>
      {[...Array<number>(pages)].map((_, pageIndex) => {
        return (
          <span
            key={pageIndex}
            className={classNames(
              styles.page,
              theme === 'light' && styles['page--theme-light'],
              pageIndex < currentPageIndex && styles['page--viewed'],
              pageIndex === currentPageIndex &&
                currentPagePaginationTime === undefined &&
                styles['page--current'],
              pageIndex === currentPageIndex &&
                currentPagePaginationTime !== undefined &&
                styles['page--current-timed'],
            )}
          >
            {currentPagePaginationTime !== undefined &&
              pageIndex === currentPageIndex && (
                <span
                  key={`${pageId}:${currentPagePaginationTime}`}
                  className={styles['page__progress']}
                  style={{
                    animationDuration: `${currentPagePaginationTime}ms`,
                  }}
                  onAnimationEnd={onPaging}
                ></span>
              )}
          </span>
        );
      })}
    </div>
  );
}
